export default __webpack_public_path__ + "static/Screen Shot 2021-12-02 at 19.30.40-04fc0e59c96e34c6a7a22a34aa97cb4c.png";